import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient"
import { PaginationResponse, ResponseData } from "../types/_public";
import { ICategory, IKeyword } from "../types/newshub/_naver";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";
const api = new APIClient();

const path_naver_search_ad = PATH_NEWSHUB_API + '/naver-search-ad';

const naverApi = {
  categories(params: any = {}): Promise<AxiosResponse<ResponseData<ICategory[]> & PaginationResponse, any>> {
    const url = `${path_naver_search_ad}/categories`
    return api.get(url, params)
  },
  searchCategories(params: any = {}): Promise<AxiosResponse<ResponseData<ICategory[]>, any>> {
    const url = `${path_naver_search_ad}/categories/all`
    return api.get(url, params)
  },
  keywords(params: any): Promise<AxiosResponse<ResponseData<IKeyword[]> & PaginationResponse, any>> {
    const url = `${path_naver_search_ad}/keywords`
    return api.get(url, params)
  },
  summaries(params: any = {}) {
    const url = `${path_naver_search_ad}/summaries`
    return api.get(url, params)
  },
}
export default naverApi
